import { useState, useEffect } from 'react';
import { useCart } from '../../hooks/useCart';
import { Link } from 'react-router-dom';

const GALLERY_IMAGES = [
  {
    src: 'https://storage.readdy-site.link/project_files/fbdeed4b-ebea-4a2a-94ca-d34ec0e1d4bd/e341b9a3-14c8-40ec-bec0-753612185c55_Capture-decran-2026-04-08-a-21.41.27.png?v=8a4dba77b3676dcd7603152b084d3a44',
    alt: 'Livre plié Bélier – vue générale',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/fbdeed4b-ebea-4a2a-94ca-d34ec0e1d4bd/29526cde-c5e5-4e3d-b517-a02c6836d41f_Capture-decran-2026-04-08-a-21.42.00.png?v=6c12d24a6203034f3d9db55325c1e549',
    alt: 'Détail relief Bélier – pliage artisanal',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/fbdeed4b-ebea-4a2a-94ca-d34ec0e1d4bd/ca179659-8e07-43a4-98e2-fd196488e92c_Capture-decran-2026-04-08-a-21.42.43.png?v=004caee6d5e19df8ed06dab4ff7f5df2',
    alt: 'Détail corne Bélier – sculpture en papier',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/fbdeed4b-ebea-4a2a-94ca-d34ec0e1d4bd/ef5f53cb-3c6d-4ba6-a29b-21070beaf8ba_Capture-decran-2026-04-08-a-21.43.13.png?v=acd331d765e4378d28f718eb91a98bcd',
    alt: 'Détail finition – vue latérale du Bélier',
  },
];

export default function ProduitBelierLivrePlie() {
  const { addToCart } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [buttonState, setButtonState] = useState<'normal' | 'adding' | 'added'>('normal');
  const [activeIndex, setActiveIndex] = useState(0);
  const productId = 'belier-livre-plie';
  const stock = 1;

  useEffect(() => {
    document.title = 'Bélier \u2648\uFE0E en livre plié – Signes du Zodiaque | Les Carnets de Lolotte';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Symbole Bélier \u2648\uFE0E en livre plié, pièce unique faite main à partir d\'un livre recyclé. Décoration minimaliste et élégante.');
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'bélier livre plié, signe zodiaque artisanal, décoration astrologique, pièce unique fait main, Les Carnets de Lolotte');
    }

    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: 'Bélier \u2648\uFE0E – Livre plié (pièce unique)',
      description: 'Symbole \u2648\uFE0E du Bélier sculpté dans les pages d\'un livre. Une pièce unique, minimaliste et élégante.',
      brand: { '@type': 'Brand', name: 'Les Carnets de Lolotte' },
      image: GALLERY_IMAGES.map(img => img.src),
      offers: {
        '@type': 'Offer',
        price: '30',
        priceCurrency: 'EUR',
        availability: 'https://schema.org/InStock',
        itemCondition: 'https://schema.org/NewCondition'
      },
      category: 'Signes du Zodiaque',
      countryOfOrigin: 'FR'
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const handleAddToCart = () => {
    if (buttonState !== 'normal') return;
    setButtonState('adding');
    addToCart({
      id: productId,
      name: 'Bélier \u2648\uFE0E – Livre plié (pièce unique)',
      price: 30,
      image: GALLERY_IMAGES[0].src,
      description: 'Symbole \u2648\uFE0E du Bélier sculpté dans les pages d\'un livre. Pièce unique faite main.'
    }, quantity);
    setButtonState('added');
    setTimeout(() => setButtonState('normal'), 2500);
  };

  const getButtonContent = () => {
    switch (buttonState) {
      case 'adding':
        return <><i className="ri-loader-4-line mr-2 animate-spin"></i>Ajout en cours...</>;
      case 'added':
        return <><i className="ri-check-line mr-2"></i>Ajouté au panier !</>;
      default:
        return <><i className="ri-shopping-cart-line mr-2"></i>Ajouter au panier • {30 * quantity}€</>;
    }
  };

  const getButtonClass = () => {
    switch (buttonState) {
      case 'adding': return 'bg-[#B97A72] text-white opacity-75 cursor-wait';
      case 'added': return 'bg-green-600 text-white';
      default: return 'bg-[#B97A72] text-white hover:bg-[#C49B86] cursor-pointer';
    }
  };

  const handlePrev = () => setActiveIndex(i => (i - 1 + GALLERY_IMAGES.length) % GALLERY_IMAGES.length);
  const handleNext = () => setActiveIndex(i => (i + 1) % GALLERY_IMAGES.length);

  return (
    <div className="min-h-screen bg-[#F8EDEA]">
      {/* Breadcrumb */}
      <div className="bg-[#FAF9F8] py-4 border-b border-[#EBD2CF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm flex-wrap gap-y-1">
            <Link to="/" className="text-[#B97A72] hover:text-[#C49B86] whitespace-nowrap" style={{ fontFamily: 'Poppins, sans-serif' }}>Accueil</Link>
            <i className="ri-arrow-right-s-line text-[#9B8B87]"></i>
            <Link to="/boutique" className="text-[#B97A72] hover:text-[#C49B86] whitespace-nowrap" style={{ fontFamily: 'Poppins, sans-serif' }}>Boutique</Link>
            <i className="ri-arrow-right-s-line text-[#9B8B87]"></i>
            <span className="text-[#9B8B87] whitespace-nowrap" style={{ fontFamily: 'Poppins, sans-serif' }}>Signes du Zodiaque</span>
            <i className="ri-arrow-right-s-line text-[#9B8B87]"></i>
            <span className="text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>Bélier ♈︎</span>
          </nav>
        </div>
      </div>

      {/* Fiche produit */}
      <section className="py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-10 lg:gap-16">

            {/* Colonne galerie */}
            <div>
              {/* Image principale */}
              <div className="relative w-full h-[420px] sm:h-[520px] bg-[#FAF9F8] border border-[#EBD2CF] rounded-lg overflow-hidden flex items-center justify-center">
                <img
                  src={GALLERY_IMAGES[activeIndex].src}
                  alt={GALLERY_IMAGES[activeIndex].alt}
                  className="w-full h-full object-contain transition-opacity duration-300"
                />

                {/* Badge pièce unique */}
                <div className="absolute top-3 left-3">
                  <span className="bg-[#C49B86] text-white px-3 py-1 rounded-full text-xs font-medium" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Pièce unique
                  </span>
                </div>

                {/* Flèches navigation */}
                <button
                  onClick={handlePrev}
                  className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white/80 hover:bg-white border border-[#EBD2CF] rounded-full cursor-pointer transition-colors"
                  aria-label="Photo précédente"
                >
                  <i className="ri-arrow-left-s-line text-[#B97A72] text-lg"></i>
                </button>
                <button
                  onClick={handleNext}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white/80 hover:bg-white border border-[#EBD2CF] rounded-full cursor-pointer transition-colors"
                  aria-label="Photo suivante"
                >
                  <i className="ri-arrow-right-s-line text-[#B97A72] text-lg"></i>
                </button>

                {/* Indicateur */}
                <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
                  {GALLERY_IMAGES.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setActiveIndex(i)}
                      className={`w-2 h-2 rounded-full transition-colors cursor-pointer ${i === activeIndex ? 'bg-[#B97A72]' : 'bg-[#C49B86]/40'}`}
                      aria-label={`Photo ${i + 1}`}
                    />
                  ))}
                </div>
              </div>

              {/* Miniatures */}
              <div className="flex gap-3 mt-4">
                {GALLERY_IMAGES.map((img, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveIndex(i)}
                    className={`w-[calc(25%-9px)] h-20 flex-shrink-0 rounded-lg overflow-hidden border-2 transition-colors cursor-pointer ${i === activeIndex ? 'border-[#B97A72]' : 'border-[#EBD2CF] hover:border-[#C49B86]'}`}
                    aria-label={img.alt}
                  >
                    <img
                      src={img.src}
                      alt={img.alt}
                      className="w-full h-full object-cover"
                    />
                  </button>
                ))}
              </div>
            </div>

            {/* Colonne infos */}
            <div className="space-y-6">
              {/* En-tête */}
              <div>
                <span className="text-xs sm:text-sm text-[#B97A72] font-medium tracking-wide uppercase" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Signes du Zodiaque
                </span>
                <h1 className="text-3xl sm:text-4xl font-bold text-[#6B5E5A] mt-2 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Bélier ♈︎ – Livre plié
                </h1>
                <p className="text-[#9B8B87] text-sm mt-1" style={{ fontFamily: 'Poppins, sans-serif' }}>Pièce unique</p>

                <div className="flex flex-wrap items-center gap-2 mt-3">
                  <span className="bg-[#C49B86] text-white px-3 py-1 rounded-full text-xs font-medium" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Pièce unique
                  </span>
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-medium" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    En stock ({stock} exemplaire)
                  </span>
                </div>
              </div>

              {/* Prix */}
              <div className="flex items-baseline gap-3">
                <span className="text-4xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>30€</span>
                <span className="text-sm text-[#9B8B87]" style={{ fontFamily: 'Poppins, sans-serif' }}>TTC · Frais de port offerts dès 15€</span>
              </div>

              {/* Description courte */}
              <p className="text-[#6B5E5A] leading-relaxed text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Le symbole ♈︎ du Bélier sculpté dans les pages d'un livre. Une pièce unique, minimaliste et élégante.
              </p>

              {/* Description longue */}
              <div className="bg-[#FAF9F8] border border-[#EBD2CF] rounded-lg p-5 space-y-3">
                <p className="text-[#6B5E5A] text-sm leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Création artisanale en livre plié : le symbole ♈︎ du signe du Bélier apparaît en relief, obtenu par un pliage précis page après page.
                  Une décoration sobre et graphique, pensée comme une pièce de caractère — à offrir ou à exposer.
                </p>
                <ul className="space-y-1.5 text-sm text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  <li className="flex items-start gap-2"><i className="ri-check-line text-[#B97A72] mt-0.5 flex-shrink-0"></i>Pièce unique (1 seul exemplaire)</li>
                  <li className="flex items-start gap-2"><i className="ri-check-line text-[#B97A72] mt-0.5 flex-shrink-0"></i>Fait main en France</li>
                  <li className="flex items-start gap-2"><i className="ri-check-line text-[#B97A72] mt-0.5 flex-shrink-0"></i>Livre recyclé (upcycling)</li>
                  <li className="flex items-start gap-2"><i className="ri-map-pin-line text-[#B97A72] mt-0.5 flex-shrink-0"></i>Hauteur : 23 cm</li>
                  <li className="flex items-start gap-2"><i className="ri-gift-line text-[#B97A72] mt-0.5 flex-shrink-0"></i>Emballage soigné, prêt à offrir</li>
                </ul>
              </div>

              {/* Dimensions */}
              <div className="flex items-center gap-4 text-sm text-[#9B8B87]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                <div className="flex items-center gap-1.5">
                  <i className="ri-ruler-line text-[#C49B86]"></i>
                  <span>Hauteur : 23 cm</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <i className="ri-recycle-line text-[#C49B86]"></i>
                  <span>Livre recyclé</span>
                </div>
              </div>

              {/* Quantité */}
              <div>
                <label className="block text-sm font-medium text-[#6B5E5A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Quantité
                </label>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    disabled={buttonState !== 'normal'}
                    className="w-10 h-10 flex items-center justify-center border-2 border-[#B97A72] text-[#B97A72] rounded-lg hover:bg-[#B97A72] hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
                  >
                    <i className="ri-subtract-line"></i>
                  </button>
                  <span className="text-xl font-semibold text-[#6B5E5A] min-w-[3rem] text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {quantity}
                  </span>
                  <button
                    onClick={() => setQuantity(Math.min(stock, quantity + 1))}
                    disabled={buttonState !== 'normal' || quantity >= stock}
                    className="w-10 h-10 flex items-center justify-center border-2 border-[#B97A72] text-[#B97A72] rounded-lg hover:bg-[#B97A72] hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
                  >
                    <i className="ri-add-line"></i>
                  </button>
                  <span className="text-xs text-[#9B8B87]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    (1 exemplaire disponible)
                  </span>
                </div>
              </div>

              {/* Bouton panier */}
              <button
                onClick={handleAddToCart}
                disabled={buttonState !== 'normal'}
                className={`w-full py-4 rounded-lg text-lg font-medium whitespace-nowrap transition-all duration-300 ${getButtonClass()}`}
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                {getButtonContent()}
              </button>

              {/* Livraison */}
              <div className="bg-[#EBD2CF] rounded-lg p-4 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-truck-line text-[#B97A72] text-xl"></i>
                </div>
                <span className="text-sm text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Livraison soignée · Emballage cadeau inclus
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section description détaillée */}
      <section className="py-12 bg-[#FAF9F8] border-t border-[#EBD2CF]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#B97A72] mb-6" style={{ fontFamily: 'Allura, cursive' }}>
            Une création artisanale unique
          </h2>
          <p className="text-[#6B5E5A] leading-relaxed mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Chaque page est pliée à la main, une à une, pour faire apparaître le symbole ♈︎ du Bélier en relief.
            Le résultat est une sculpture graphique et minimaliste, qui s'expose comme une œuvre d'art.
          </p>
          <p className="text-[#6B5E5A] leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Réalisée à partir d'un livre recyclé, cette création s'inscrit dans une démarche d'upcycling poétique :
            donner une seconde vie aux livres en les transformant en objets décoratifs chargés de sens.
          </p>
        </div>
      </section>

      {/* Retour boutique */}
      <div className="py-8 text-center">
        <Link
          to="/boutique"
          className="inline-flex items-center text-[#6B5E5A] hover:text-[#B97A72] transition-colors"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          <i className="ri-arrow-left-line mr-2"></i>
          Retour à la boutique
        </Link>
      </div>
    </div>
  );
}
